export { UserAlt as default } from './UserAlt';
